<template>
    <component v-model="form" :is="FormComponent" v-bind="{ program }" @input="emit">
        <template #activator="{ attrs, on, loading, isNext }">
            <slot name="activator" v-bind="{ attrs, on, loading, isNext }" />
        </template>
    </component>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { initExpoProgram, USER_TYPES } from "@/assets/variables";

import DialogLogin from "@/components/client/login/dialog-login.vue";
import ExpoEmployeeForm from "@/components/client/expo/employee/expo-employee-form.vue";
import ExpoEmployerForm from "@/components/client/expo/employer/expo-employer-form.vue";
import ApplyNext from "./apply/apply-next.vue";
import ApplyNoti from "./apply/apply-noti.vue";

export default {
    components: {
        DialogLogin,
        ExpoEmployeeForm,
        ExpoEmployerForm,
        ApplyNext,
        ApplyNoti,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
    },
    data: () => ({
        form: {},

        loading: false,
    }),
    computed: {
        ...mapGetters(["_user", "isUserLoggedIn", "doesUserHaveConsoleScope"]),
        ...mapState({
            userType: (store) => store.payload?.userType,
        }),
        FormComponent() {
            if (!this.isUserLoggedIn) {
                return "dialog-login";
            }

            const isUserHost = this._user == this.program.host._user;
            const isUserApplied = !!this.form._id;
            if (this.doesUserHaveConsoleScope || isUserHost || isUserApplied) {
                return "apply-next";
            }

            switch (this.userType) {
                case USER_TYPES.PERSON.value: {
                    return "expo-employee-form";
                }
                case USER_TYPES.COMPANY.value: {
                    return "expo-employer-form";
                }

                default: {
                    return "apply-noti";
                }
            }
        },
    },
    methods: {
        emit() {
            switch (this.userType) {
                case USER_TYPES.PERSON.value: {
                    this.$emit("setEmployee", this.form);
                    break;
                }
            }
        },
    },
};
</script>

<style>
</style>